// extracted by css-extract-rspack-plugin
export default {"actionButtons":"WhqPgq4giIk9Xmxc","body":"vO0eDQmbym8ohm6N","featureList":"C_EbwWrI7BwXgxDn"};